/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileCardSchema } from './profileCardSchema';
import type { SearchProfilesResponseSchemaAggregations } from './searchProfilesResponseSchemaAggregations';

export interface SearchProfilesResponseSchema {
  profiles: ProfileCardSchema[];
  total_count: number;
  total_count_is_estimate?: boolean;
  page: number;
  per_page: number;
  aggregations?: SearchProfilesResponseSchemaAggregations;
  filters_unavailable?: string[];
}
